module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE4IDE0Ij4KICA8dGl0bGU+Q29uc2VudCBnaXZlbjwvdGl0bGU+CiAgPHBhdGggZD0iTTUuOTk5OTcgMTEuMTdMMS44Mjk5NyA3LjAwMDAzTDAuNDA5OTczIDguNDEwMDNMNS45OTk5NyAxNEwxOCAyLjAwMDAzTDE2LjU5IDAuNTkwMDI3TDUuOTk5OTcgMTEuMTdaIiBmaWxsPSIjMTAzMkNGIj48L3BhdGg+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/correction.svg
// module id = Gy1N
// module chunks = 6